// extracted by mini-css-extract-plugin
export default {"pinWindow":"ChatScreen_pinWindow__97OKI","pinMinimized":"ChatScreen_pinMinimized__8SX75"};